import {Component, EventEmitter, Input, OnInit, Output, TemplateRef,} from '@angular/core';
import {Piano} from "../../../models/Piano";
import {DataService} from "../../../services/data.service";
import {ActivatedRoute} from "@angular/router";
import _ from "lodash";
import {observable} from "rxjs";

export class HeaderComponentLink {
   text: string = ""
   link?: string
   active?: boolean;
   index?: number;
   show?:boolean;
   has_badge?:boolean;
   force_save?:boolean;
   onClick?: () => void
}

@Component({
   selector: 'app-header-top',
   templateUrl: './header-top.component.html',
   styleUrls: ['./header-top.component.scss']
})
export class HeaderTopComponent implements OnInit {
   @Input() title:string = ''
   @Input() pVenditaName:string | null = null
   @Input() subtitle:string = ''
   @Input() optionTemplate: TemplateRef<any> | null = null;
   @Input() links:HeaderComponentLink[] = []
   @Input() breadcrumbs:HeaderComponentLink[] = []
   @Input() showClickSave:boolean = false
   @Input() showExit:boolean = false
   @Input() pvenditaId:number|null = null
   @Output() onLinkClick:EventEmitter<HeaderComponentLink> = new EventEmitter<HeaderComponentLink>()
   @Output() clickSave:EventEmitter<any> = new EventEmitter<any>()
   @Output() clickExit:EventEmitter<any> = new EventEmitter<any>()
   vendorSlug;

   show:boolean = false;
   sticky:boolean = true
   pv_name:string = '';

   constructor(public dataSrv: DataService,
               private route:ActivatedRoute
   ) {
      if (!this.pvenditaId){
         this.route.parent?.parent?.params.subscribe(params => {
            this.pvenditaId = params['pvendita_id'];
         })
         this.vendorSlug = this.route.parent?.parent?.parent?.snapshot.params['esercizio_slug']
      }
   }

   ngOnInit(): void {

      this.route.parent?.parent?.params.subscribe(params => {
         console.log(params)
         const x = _.filter(this.dataSrv.puntiVendita, x => x.p_vendita.ID == this.pvenditaId)
         const pVendita = x[0]
         if (pVendita){
            this.pv_name = pVendita.data.p_vendita__nome!
         }
      })

      this.sticky = this.links.length > 0
      console.log(this.links)
   }

   clickExpandMobileMenu() {
      this.show = !this.show
   }

   clickBreadcrumb(link: HeaderComponentLink, i){
      setTimeout(() =>{
         for (const l of this.breadcrumbs) l.active = false
         link.active = true
         if (link.force_save)this.clickSave.emit()
         this.onLinkClick.emit(link)
         if(link.onClick) link.onClick()
      }, 300)

   }

   clickTab(link: HeaderComponentLink) {
      for (const l of this.links) l.active = false
      link.active = true
      this.onLinkClick.emit(link)
      if(link.onClick) link.onClick()
   }

   clickSaveExit() {
      this.clickSave.emit(true)
   }

   onclickExit() {
      this.clickExit.emit(true)
   }

   protected readonly Piano = Piano;
}
